export default "__VITE_ASSET__6e244791__"